export default {
  id: 118,
  title: 'Target #118 - Donkey Kong',
  url: 'https://cssbattle.dev/play/118',
  colors: ['#000000', '#AF067C', '#FFFFFF'],
  solution:
    '<a a><a b><a c><style>[b],[c]{left:50;width:300;height:20;border-radius:9in;background:#af067c}body{background:#000}a{position:fixed}[a]{top:100;left:80;width:20;height:60;background:#fff;color:#fff;box-shadow:220px 0,110px 45px,220px 45px}[b]{top:140;transform:rotate(-4deg)}[c]{top:90;box-shadow:0 100px #af067c}</style>',
}
